import React, {useState} from 'react';
import './PostFeel.css';
import {Avatar, Button} from '@material-ui/core';
import LibraryBooksOutlinedIcon from '@material-ui/icons/LibraryBooksOutlined';
import AddPhotoAlternateOutlinedIcon from '@material-ui/icons/AddPhotoAlternateOutlined';
import ArrowDropDownOutlinedIcon from '@material-ui/icons/ArrowDropDownOutlined';
import MovieCreationOutlinedIcon from '@material-ui/icons/MovieCreationOutlined';
import LocalMallOutlinedIcon from '@material-ui/icons/LocalMallOutlined';
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined';
import InsertPhotoOutlinedIcon from '@material-ui/icons/InsertPhotoOutlined';
import db from "./firebase";
import firebase from "firebase";
import { storage } from "./firebase";

function PostFeel({username, profilePic, userId}) {
    const [join, setJoin] = useState(true);
    const posting = () => {
        setJoin(!join);
        setPosttype('blog')
    }
    const close__box = () => {
        setJoin(!join);
    }
    const [video, setVideo] = useState('');
    const [movie, setMovie] = useState('');
    const [price, setPrice] = useState('');
    const [currency, setCurrency] = useState('');
    const [posttype, setPosttype] = useState('');
    const [message, setMessage] = useState('');
    const [photo, setPhoto] = useState('');
    const handleChange = e => {
        if(e.target.files[0]) {
            setPhoto(e.target.files[0]);
        }
    };
    const closeImg = () => {
        setPhoto('');
    }
    const handleSubmit = (event) => {
        event.preventDefault();
        const uploadTask = storage.ref(`images/${photo.name}`).put(photo);
        
        if(posttype=="blog"){
            uploadTask.on (
                "state_changed",
                snapshot => {},
                error => {
                    console.log(error);
                },
                () => {
                    storage
                    .ref("images")
                    .child(photo.name)
                    .getDownloadURL()
                    .then(url => {
                        db.collection('posts').add({
                            postType: posttype,
                            message: message,
                            timestamp: firebase.firestore.FieldValue.serverTimestamp(),
                            image:url,
                            like: 0,
                            likeScore: 0,
                            userId: userId, 
                            profilePic: profilePic,
                            username: username
                        })
                        
                    });
                }
            )
        } else if(posttype=='photo') {
            uploadTask.on (
                "state_changed",
                snapshot => {},
                error => {
                    console.log(error);
                },
                () => {
                    storage
                    .ref("images")
                    .child(photo.name)
                    .getDownloadURL()
                    .then(url => {
                        db.collection('posts').add({
                            postType: posttype,
                            message: message,
                            timestamp: firebase.firestore.FieldValue.serverTimestamp(),
                            image:url,
                            like: 0,
                            likeScore: 0,
                            userId: userId, 
                            profilePic: profilePic,
                            username: username
                        })
                        
                    });
                }
            )
        } else if(posttype=="video") {
            db.collection('posts').add({
                postType: posttype,
                message: message,
                timestamp: firebase.firestore.FieldValue.serverTimestamp(),
                video:video,
                like: 0,
                likeScore: 0,
                userId: userId, 
                profilePic: profilePic,
                username: username
            })
        } else if(posttype=="movie"){
            uploadTask.on (
                "state_changed",
                snapshot => {},
                error => {
                    console.log(error);
                },
                () => {
                    storage
                    .ref("images")
                    .child(photo.name)
                    .getDownloadURL()
                    .then(url => {
                        db.collection('posts').add({
                            postType: posttype,
                            message: message,
                            timestamp: firebase.firestore.FieldValue.serverTimestamp(),
                            movie:movie,
                            image:url,
                            like: 0,
                            likeScore: 0,
                            userId: userId,
                            profilePic: profilePic,
                            username: username
                        })
                        
                    });
                }
            )
        } else if(posttype=="shop"){
            uploadTask.on (
                "state_changed",
                snapshot => {},
                error => {
                    console.log(error);
                },
                () => {
                    storage
                    .ref("images")
                    .child(photo.name)
                    .getDownloadURL()
                    .then(url => {
                        db.collection('posts').add({
                            postType: posttype,
                            message: message,
                            timestamp: firebase.firestore.FieldValue.serverTimestamp(),
                            price:price,
                            currency:currency,
                            image:url,
                            like: 0,
                            likeScore: 0,
                            userId: userId,
                            profilePic: profilePic,
                            username: username
                        })
                    });
                }
            )
        }
        setMessage('');
        setPhoto('');
        setJoin(!join);
    }
    
    return (
        <div className="postFeel">
            <div className="input__line">
                <Avatar src={profilePic}/>
                <Button onClick={posting}>What's on your mind?</Button>
            </div>
            <div className="button__ling">
                <Button><LibraryBooksOutlinedIcon 
                style={{color:'#fdc513', marginRight:'10px'}}
                /> Story</Button>
                <Button><AddPhotoAlternateOutlinedIcon
                style={{color:'#0a771c', marginRight:'10px'}}
                /> Photo/Video</Button>
                <Button>More <ArrowDropDownOutlinedIcon 
                style={{color:'#e50914', marginLeft:'10px'}}
                /> </Button>
                <div className="more__expand" style={{display:'none'}}>
                    <Button><MovieCreationOutlinedIcon/> Movies</Button>
                    <Button><LocalMallOutlinedIcon/> Shop</Button>
                </div>
            </div>
            <div className={`create__postout ${join && "hide__createPost"}`}>
                <div className="create__post">
                    <Button 
                    className="close__button"
                    onClick={close__box}
                    ><CloseOutlinedIcon  /></Button>
                    <h2 className="blog__title">Create Post</h2>
                    <div className="post__type">
                        <p>Post type</p>
                        <select value={posttype}
                        onChange={e=>setPosttype(e.target.value)}
                        >
                            <option value="blog">Blog</option>
                            <option value="photo">Photo</option>
                            <option value="video">Video</option>
                            <option value="movie">Movie</option>
                            <option value="shop">Sell Product</option>
                        </select>
                    </div>
                    <div className="user__avatar"><Avatar src={profilePic} /><label>{username}</label></div>
                    <textarea 
                    placeholder="What's on you mind?" 
                    className="text__box "
                    value={message} onChange={(event)=>setMessage(event.target.value)}
                    />
                    <input placeholder="Insert Video Url or Link" 
                    className={`video__url ${posttype=="video" && "video__show"}`}
                    value={video}
                    onChange={e=>setVideo(e.target.value)}
                    />
                    <input placeholder="Insert Movie Url or Link" 
                    className={`video__url ${posttype=="movie" && "movie__show"}`}
                    value={movie}
                    onChange={e=>setMovie(e.target.value)}
                    />
                    <p className={`img__label ${!photo.name && "hide__label"}`}>
                        <div className="label__one">
                            <InsertPhotoOutlinedIcon/> {photo.name}
                        </div>
                        <div className="label__two">
                            <CloseOutlinedIcon onClick={closeImg} />
                        </div>
                    </p>
                    <Button className={`fake__fileBox ${posttype=="video" && "filebox__hide"}`} >{
                    posttype=="movie" && "Movie Poster Photo : "||
                    posttype=="photo" && "Choose Photo : "||
                    posttype=="blog" && "Choose Blog Photo : "||
                    posttype=="shop" && "Choose Product Photo : "
                    } {' '} <InsertPhotoOutlinedIcon/></Button>
                    <input type="file" 
                    className={`file__box ${posttype=="video" && "filebox__hide"}`}
                    onChange={handleChange}
                    />
                    <div className={`product__box ${posttype=="shop" && "product__show"}`}>
                        <input placeholder="Product Price" 
                        className='price__product'
                        value={price}
                        onChange={e=>setPrice(e.target.value)}
                        />
                        <select className="currency"
                        value={currency}
                        onChange={e=>setCurrency(e.target.value)}
                        >
                            <option>MMK</option>
                            <option>USD</option>
                        </select>
                    </div>
                    <Button disabled={!message} type="submit" className="post__button" onClick={handleSubmit} >Post</Button>
                </div>
            </div> 
        </div>
    )
}

export default PostFeel
